import axios from "axios";
import config from "../config";

let wizard = new Object({
  fetchBlog: (site_id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/wizard/fetchBlogs",
        data: { site_id: site_id },
        method: "POST",
      })
        .then((res) => {
          resolve(res.data.responseData);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getBlog: (site_id,blog_id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/wizard/getBlog",
        data: { site_id : site_id, blog_id: blog_id },
        method: "POST",
      })
        .then((res) => {
          resolve(res.data.responseData);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  addBlog: (site_id,blog) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/wizard/addBlog",
        data: { site_id : site_id, blog: blog },
        method: "POST",
      })
        .then((res) => {
          resolve(res.data.responseData);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateBlog: (site_id,blog) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/wizard/updateBlog",
        data: { site_id : site_id , blog: blog },
        method: "POST",
      })
        .then((res) => {
          resolve(res.data.responseData);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  deleteBlog: (site_id, id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/wizard/deleteBlog",
        data: { blog_id: id, site_id: site_id },
        method: "POST",
      })
        .then((res) => {
          resolve(res.data.responseData);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchMeta: () => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/wizard/defaultMeta",
        data: {},
        method: "POST",
      })
        .then((res) => {
          resolve(res.data.responseData);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setWizardSteps: (state) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/wizard/steps",
        data: state,
        method: "POST",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setEditingMeta: (state, build_id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/editor/meta",
        data: {
          meta: state,
          build_id: build_id,
        },
        method: "POST",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  collectMeta: (build_id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/editor/collect",
        data: {
          build_id: build_id,
        },
        method: "POST",
      })
        .then((res) => {
          resolve(res.data.responseData.meta);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getWizardState: () => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/wizard/state",
        method: "POST",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setInvoiceDetails: (invoice, build_state_id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/wizard/invoice",
        data: {
          invoice: invoice,
          build_state_id: build_state_id,
        },
        method: "POST",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  completeWizard: (payload) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/wizard/complete",
        data: { payload: payload },
        method: "POST",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
});

export default wizard;
